import { ScreenService } from './../../shared/services/screen/screen.service';
import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Experience } from "./interfaces/experience.interface";
import { CommonModule } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-experience',
  standalone: true,
  imports: [
    CommonModule, 
    TranslatePipe
  ],
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.css'],
})
export class ExperienceComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  objectKeys = Object.keys;
  experiences: Experience[] = [];
  visibleTechnologies = new Set<number>();
  isMobile = false;

  iconMap: Record<string, string> = {
    coreDevelopment: 'fas fa-code',
    cloudAndAzureServices: 'fas fa-cloud',
    databases: 'fas fa-database',
    testingAndDocumentation: 'fas fa-vial',
    infrastructure: 'fas fa-network-wired',
    devopsAndTools: 'fas fa-tools',
    agileMethodologies: 'fas fa-project-diagram',
    projectManagement: 'fas fa-tasks',
    rpaAndAutomation: 'fas fa-robot',
    reportingAndDocumentGeneration: 'fas fa-file-invoice'
  };

  constructor(
    private translate: TranslateService,
    private screenService: ScreenService
  ) {}

  ngOnInit(): void {
    this.loadExperiences();

    this.screenService.isMobile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isMobile) => {
      this.isMobile = isMobile;
    });

    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadExperiences();
    });
  }

  loadExperiences(): void {
    this.translate
      .get('experience.experiences')
      .subscribe((data: Experience[]) => {
        this.experiences = data;
      });
  }

  toggleTechnologies(index: number): void {
    if (this.visibleTechnologies.has(index)) {
      this.visibleTechnologies.delete(index);
    } else {
      this.visibleTechnologies.add(index);
    }
  }

  isTechnologyVisible(index: number): boolean {
    return this.visibleTechnologies.has(index);
  }

}


